import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Skeleton, OrderSummarySkeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function ShoppingCartSkeleton() {
    const { isMobileView } = useWindowSize();
    return (React.createElement(Row, null,
        React.createElement(Col, { lg: 7 },
            React.createElement(Skeleton, { skeletonProps: {
                    height: isMobileView ? 220 : 280,
                }, wrapperProps: {
                    mlS: -16,
                    mrS: -16,
                    mlM: 0,
                    mrM: 0,
                } })),
        React.createElement(Col, { lg: 5 },
            React.createElement(OrderSummarySkeleton, null))));
}
